import React from 'react';

const VersionFooter = () => {
  const buildTime = new Date().toLocaleString();

  return (
    <footer className="text-center text-sm text-gray-500 mt-8">
      App Version: <strong>0.1.2</strong> — Last Build: <em>{buildTime}</em>
    </footer>
  );
};

export default VersionFooter;
